export const isChromeBrowser = (): boolean =>
  /Chrome/.test(navigator?.userAgent) && !/Edge/.test(navigator?.userAgent);
